jQuery(document).ready(function ($) {

    const closeAllPopups = () => {
        $('body').css({ overflow: 'unset' });
        $('.popup').removeClass('active');
    };
    const openPopup = (selector) => {
        if(!$(selector).length)
            return;
        $(".cross").click();
        closeAllPopups();
        $('body').css({ overflow: 'hidden' });
        $(selector).addClass('active');
    };

    $('.popup-open').click(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openPopup($(this).attr('href'));
    });

    $('a[href*="#"]').click(function (e) {
        const href = $(this).attr('href'),
            id = '#' + href.split('#')[1];
        if(id === '#')
            return;
        const $section = $(id);
        if($section.length && $section.hasClass('popup')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            openPopup(href);
        }
    });

    $('.popup-close').click(function (e) {
        e.preventDefault();
        $('body').css({ overflow: 'unset' });
        $(this).closest('.popup').removeClass('active');
    });
});
